import { FC } from 'react';
import { QrCodeProps } from './types';
import { QRCode } from 'antd';
import './QrCode.scss';

const QrCode: FC<QrCodeProps> = ({ value }) => {
    return (
        <div className="qr-code">
            <div className="qr-code__content">
                <QRCode value={value} />
            </div>
        </div>
    );
};

export default QrCode;
